import * as SVG from "@/svgs";
import { ModuleProps } from "@/utils/types";
import { SvgSelector } from "../SvgSelector";
import { addBreak } from "@/utils/addBreak";
import { sanitize } from "@/utils/sanitize";

export interface IconFeatureProps extends ModuleProps {
  icon: keyof typeof SVG;
  heading?: string;
  copy?: string;
}

export const IconFeature = ({
  className,
  lightMode,
  componentId,
  icon,
  heading,
  copy,
}: IconFeatureProps) => {
  return (
    <div
      id={componentId}
      className={`iconFeature ${
        lightMode ? "lightMode" : "darkMode"
      } flex  flex-col gap-4 justify-start md:justify-center items-center max-w-[280px] xms:w-[calc(50%-0.5rem)] md:w-full text-center${className ? ` ${className}` : ""}`}
    >
      <div className="h-[95px] flex items-center justify-center">
        {icon && <SvgSelector name={icon} />}
      </div>
      {heading && (
        <p
          className={`${
            lightMode ? "text-secondaryDark" : "text-tertiary"
          } font-display text-[22px] md:text-[35px] text-pretty leading-[1]`}
        >
          {addBreak(sanitize(heading), 1)}
        </p>
      )}
      <p
        className={`w-[80%] md:w-auto font-bold text-pretty text-[14px] md:text-[16px] ${lightMode ? "text-secondaryDark" : "text-white"}`}
      >
        {copy}
      </p>
    </div>
  );
};
